import '@babel/polyfill'

import Vue from 'vue'
import './highcharts'
import './vue-slider-bar'
import App from './App.vue'

import '@/filters/filters'
import { i18n } from './i18n';
import { Config, ConfigSettings } from './utils/Config';

declare var sodraAppEnv: any;

Vue.config.productionTip = false;

if (process.env.NODE_ENV === 'development') {
  const configSettings: ConfigSettings = {
    ApiBaseUrl: process.env.VUE_APP_API_BASE_URL,
    UseDataSwitch: process.env.VUE_APP_USE_DATA_SWITCH === 'true',
    SliderOnTop: process.env.VUE_APP_SLIDER_ON_TOP === 'true',
    Year: Number(process.env.VUE_APP_YEAR),
    SummaryCompareWithLastYear: process.env.VUE_APP_SUMMARY_COMPARE_WITH_LAST_YEAR === 'true',
    ChartsPrimaryColor: process.env.VUE_APP_CHARTS_PRIMARY_COLOR,
    ChartsSecondaryColor: process.env.VUE_APP_CHARTS_SECONDARY_COLOR
  };
  
  Config.SetSettings(configSettings);

  new Vue({
    i18n,
    render: h => h(App)
  }).$mount('#app')

} else {

  // Register the library at sodra.com:
  sodraAppEnv.v1.registerLib('insect_damage_report', {
    InsectDamageReport(elem: any, appContext: any) {
      if (appContext !== undefined && appContext.CustomValues) {
        Config.SetSettings(appContext.CustomValues);
      }

      new Vue({
        i18n,
        render: h => h(App)
      }).$mount(elem)
    }
  });
  
}